import { RuleFn } from './types';

// 根据权限过滤(基于 auth 字段, null 和'超级管理员'无条件放行)
export const byAuth: RuleFn = (menuItem, { userInfo, userAuth }) => {
  const authInMenu = menuItem.auth || []; // 菜单上设置的权限
  const isAdmin = userInfo.isSuperAdmin;  // 是否是超级管理员
  const hasAuth = authInMenu.some((item) => (item === null) || userAuth.indexOf(item) > -1);
  return isAdmin || hasAuth;
};

// 根据权限或收费会员过滤(收费会员无条件放行, VIP会员或组织根据权限判断是否放行)
export const byMember: RuleFn = (menuItem, conditions) => {
  return (conditions.userInfo.orgType === 99) || byAuth(menuItem, conditions);
};

// 根据权限或VIP会员过滤(仅放行VIP会员, 其他类型的会员全部拦截)
export const byVip: RuleFn = (menuItem, conditions) => {
  return (conditions.userInfo.orgType === 2) && byAuth(menuItem, conditions);
};

// 根据增值服务编码和权限过滤(基于 moduleCode 和 auth 字段, 其中 moduleCode 权重更高)
export const byModuleCode: RuleFn = (menuItem, conditions) => {
  const moduleCodeInMenu = menuItem.moduleCode || [];     // 菜单上设置的增值服务编码
  const moduleCodeInUsed = conditions.userModules || [];  // 登录用户所在组织拥有的增值服务
  const hasModule = moduleCodeInMenu.some((item) => moduleCodeInUsed.indexOf(item) > -1);
  return hasModule && byAuth(menuItem, conditions);
};

// 根据组织是否是城市服务中心和权限过滤
export const byDesignCenter: RuleFn = (menuItem, conditions) => {
  // 登录用户所在组织拥有的客户类型
  const typesInUsed = conditions.orgInfo.additionalTypes || [];
  // 是否是城市服务中心(客户类型既是代理商(1), 也是设计服务商(2))
  const isDesignCenter = [1, 2].every((item) => typesInUsed.indexOf(item) > -1);
  return isDesignCenter && byAuth(menuItem, conditions);
};
